import { CropMode } from '@/utils/types';

export const DEFAULT_BACKGROUND_QUERY = 'empty office-space';

export const DEFAULT_SCENE_DURATION_IN_MS = 5000;

export const MAX_SCENE_DURATION_IN_MS = 5 * 60 * 1000; // 5min

export const MAX_VIDEO_DURATION_IN_MS = 30 * 60 * 1000; // 30min

export const MAX_SCENE_COUNT = 10;

export const POLOTNO_DURATION_SELECTOR = '.polotno-play-button-container > div:nth-child(2)';

export const resolutions: Record<CropMode, { width: number; height: number }> = {
    [CropMode.Wide]: { width: 1920, height: 1080 },
    [CropMode.Square]: { width: 1080, height: 1080 },
    [CropMode.Vertical]: { width: 1080, height: 1920 },
    [CropMode.Circle]: { width: 1080, height: 1080 },
    [CropMode.Fit]: { width: 1920, height: 1080 },
};
